import { useState } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

// Sequential emerald -> teal -> sky ramp, ordered with the buckets
const sliceColour = (i, n) => {
  const t = n <= 1 ? 0 : i / (n - 1);
  const hue = 150 + t * 55;
  const light = 68 - t * 22;
  return `hsl(${hue}, 62%, ${light}%)`;
};

const fmtPct = (p) => `${p.toFixed(p >= 10 ? 0 : 1)}%`;

export const DonutBreakdown = ({ title, icon: Icon, items, testId }) => {
  const [active, setActive] = useState(null);
  const data = (items || []).map((it) => ({ label: it.range, pct: Number(it.pct) || 0 })).filter((d) => d.pct > 0);
  if (data.length === 0) return null;
  const top = data.reduce((a, b) => (b.pct > a.pct ? b : a), data[0]);
  const focus = active != null ? data[active] : top;

  return (
    <div className="bg-slate-900/40 border border-emerald-400/15 rounded-xl p-4" data-testid={testId}>
      <div className="flex items-center gap-2 mb-2">
        {Icon && <Icon className="w-3.5 h-3.5 text-emerald-300" />}
        <p className="text-[10px] uppercase tracking-[0.16em] text-slate-400 font-bold">{title}</p>
      </div>
      <div className="relative h-44" data-testid={`${testId}-donut`}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              dataKey="pct"
              nameKey="label"
              innerRadius="62%"
              outerRadius="92%"
              paddingAngle={1.5}
              stroke="none"
              startAngle={90}
              endAngle={-270}
              onMouseEnter={(_, i) => setActive(i)}
              onMouseLeave={() => setActive(null)}
              isAnimationActive
            >
              {data.map((d, i) => (
                <Cell key={d.label} fill={sliceColour(i, data.length)} opacity={active == null || active === i ? 1 : 0.35} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
          <p className="text-white text-xl font-bold tabular-nums leading-none" data-testid={`${testId}-center-pct`}>{fmtPct(focus.pct)}</p>
          <p className="text-slate-300 text-[11px] mt-1 max-w-[90px] text-center leading-tight">{focus.label}</p>
          {active == null && <p className="text-emerald-300/80 text-[9px] uppercase tracking-wider mt-0.5">largest group</p>}
        </div>
      </div>
      <ul className="grid grid-cols-2 gap-x-3 gap-y-1 mt-3">
        {data.map((d, i) => (
          <li
            key={d.label}
            className={`flex items-center gap-1.5 text-[11px] cursor-default transition-opacity ${active == null || active === i ? "opacity-100" : "opacity-50"}`}
            onMouseEnter={() => setActive(i)}
            onMouseLeave={() => setActive(null)}
            data-testid={`${testId}-row-${i}`}
          >
            <span className="w-2 h-2 rounded-full shrink-0" style={{ background: sliceColour(i, data.length) }} />
            <span className="text-slate-200 truncate">{d.label}</span>
            <span className="text-slate-400 tabular-nums ml-auto">{fmtPct(d.pct)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DonutBreakdown;
